<ion-app id="infomenuContent">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<app-device-info></app-device-info>
